/// <reference types="vite-plugin-svgr/client" />

import BackpackIcon from '@/assets/icons/backpack.svg?react'
import BookmarkIcon from '@/assets/icons/bookmark.svg?react'
import HomeIcon from '@/assets/icons/budget/budgetCategoryHousing.svg?react'
import VehicleIcon from '@/assets/icons/car.svg?react'
import CreditCardIcon from '@/assets/icons/cc.svg?react'
import ChairIcon from '@/assets/icons/chair.svg?react'
import CheckingIcon from '@/assets/icons/checking.svg?react'
import DebtIcon from '@/assets/icons/debt.svg?react'
import PersonalLoanIcon from '@/assets/icons/dollarHand.svg?react'
import DollarHomeIcon from '@/assets/icons/dollarHome.svg?react'
import CashIcon from '@/assets/icons/invest.svg?react'
import OtherIcon from '@/assets/icons/other.svg?react'

export const TYPE_GROUP = {
  cash: {
    icon: CashIcon,
    label: 'Cash',
  },
  credit_cards: {
    icon: CreditCardIcon,
    label: 'Credit Cards',
  },
  investments: {
    icon: CheckingIcon,
    label: 'Investments',
  },
  loan: {
    icon: DebtIcon,
    label: 'Loan',
  },
  mortgage: {
    icon: DollarHomeIcon,
    label: 'Mortgage',
  },
  other: {
    icon: OtherIcon,
    label: 'Other',
  },
  personal_loan: {
    icon: PersonalLoanIcon,
    label: 'Personal Loan',
  },
  real_estate: {
    icon: HomeIcon,
    label: 'Real Estate',
  },
  retirement: {
    icon: ChairIcon,
    label: 'Retirement',
  },
  savings: {
    icon: BookmarkIcon,
    label: 'Savings',
  },
  student_loan: {
    icon: BackpackIcon,
    label: 'Student Loan',
  },
  vehicle: {
    icon: VehicleIcon,
    label: 'Vehicle',
  },
}
